// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__DsZEA","active":"NavigationItem_active__31KiE"};